import polyglotI18nProvider from 'ra-i18n-polyglot'
// import englishMessages from './en'
import thaiMessages from './th'

const initialLocale = localStorage.getItem('RaStore.locale') || 'th'
const translations = { /* en: englishMessages, */ th: thaiMessages }

export const i18nProvider = polyglotI18nProvider((locale) => translations[locale], initialLocale, {
  allowMissing: true,
})
